import { Box, Button, styled } from "@mui/material";
import Skeleton from "react-loading-skeleton";
import { IWithClassName, IWithThemeProps } from "../../../theme/default.theme";
import { ISectionDetails } from "../interface/section";

interface ISectionLinkProps {
    links: Array<ISectionDetails>;
    isLoading: boolean;
}

const SectionNavigation = ({
    className,
    links,
    isLoading,
}: IWithClassName & ISectionLinkProps) => {
    const scrollToSection = (slug: string) => {
        const element = document.getElementById(slug);
        if (!element) return;

        const offset = 100;
        const elementTopPosition =
            element.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementTopPosition - offset;

        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
        });
    };

    return (
        <div className={className}>
            {isLoading ? (
                <Box className="loader-container">
                    <Skeleton />
                    <Skeleton />
                </Box>
            ) : (
                links.map((links) => (
                    <Button
                        className="link-button"
                        key={links.slug}
                        onClick={() => scrollToSection(links.slug)}
                        disableFocusRipple={true}
                        disableRipple={true}
                        disableTouchRipple={true}
                    >
                        {links.title}
                    </Button>
                ))
            )}
        </div>
    );
};

export default styled(SectionNavigation)(({ theme }: IWithThemeProps) => ({
    marginBottom: theme?.spacing(12),
    ".link-button": {
        fontSize: "16px",
        fontWeight: "bold",
        textTransform: "none",
        color: theme?.palette.faqSection.textColor,
    },
    ".loader-container": {
        display: "flex",
        gap: 20,
        width: 200,
        span: {
            flex: 1,
        },
    },
}));
